import { HarnessFlagSet } from 'adapters/types/Client';
import {
  getFormattedHarnessFlags,
  getHarnessFlagValue
} from 'pages/LandingPage/slice';
import { useAppSelector } from 'store/hooks';

export const useFlags = (): HarnessFlagSet =>
  useAppSelector(getFormattedHarnessFlags);

export const useFlagValue = (flagValue: string): boolean | undefined =>
  useAppSelector(getHarnessFlagValue(flagValue));
